import { createContext } from 'react';

export interface NewsletterModalContextType {
  openNewsletterModal: () => void;
}

export const NewsletterModalContext = createContext<NewsletterModalContextType>(
  { openNewsletterModal: () => null }
);
